import { ChainID } from '@ankr.com/chains-list';

export const ALL_CHAINS_VALUE = ChainID.UNDEFINED;
